import { defineMeta } from '@/registry/types';

export const leftNavigationMeta = defineMeta({
  name: 'LeftNavigation',
  level: 'organism',
  category: 'navigation',
  classification: 'custom',
  description: 'Primary vertical app navigation with selected state and collapsed icon-only mode.',
  baseLibrary: 'custom',
  muiEquivalent: 'List + ListItemButton (composed)',
  muiDocs: 'https://mui.com/material-ui/react-list/',
  a2uiEquivalent: 'Sidebar / NavRail',
  importPath: '@/organisms/LeftNavigation',
  requiredProps: ['items'],
  optionalProps: [
    'selectedId',
    'onSelect',
    'collapsed',
    'header',
    'width',
    'collapsedWidth',
    'linkComponent',
  ],
  supportedStates: ['default', 'selected', 'collapsed', 'hover'],
  designTokens: ['colors', 'radius', 'spacing'],
  accessibility: [
    'Renders a nav landmark with aria-label="Primary".',
    'Collapsed items expose labels via tooltips.',
    'Items with an href render as links and carry aria-current="page" when selected.',
  ],
  usageExamples: [
    '<LeftNavigation items={items} selectedId={id} onSelect={setId} />',
    "<LeftNavigation linkComponent={Link} selectedId={pathname} items={nav.map(({ to, label, icon }) => ({ id: to, label, icon, href: to }))} />",
  ],
  rules: [
    'Give each item an href when it maps to a route, so the rail renders links and keeps new-tab clicks, the link context menu and route prefetch.',
    'Pass linkComponent for a router-aware app (next/link, react-router Link) to keep navigation client-side; it defaults to a plain anchor.',
    'With href set, treat onSelect as a notification (analytics, closing a mobile drawer) - the link performs the navigation, and onSelect does not fire on modified clicks.',
    'Use per-item target and rel only for destinations outside the app.',
  ],
  antiPatterns: [
    'Do not duplicate global actions already in the AppBar.',
    'Do not navigate from onSelect when the item has an href; that double-navigates a cmd-clicked item.',
    'Do not omit href and route through onSelect alone for real destinations; middle-click and cmd-click cannot work on a button.',
  ],
  llmSafe: true,
  whenToUse: ['App shell primary navigation'],
  whenNotToUse: ['In-page view switching (use Tabs)'],
});

export default leftNavigationMeta;
